document.addEventListener('DOMContentLoaded', function () {
  function initProductReviewsSwipers() {
    const blocks = document.querySelectorAll('.pdp-customer-reviews-block');
    if (!blocks.length) return;

    if (typeof Swiper === 'undefined') return;

    blocks.forEach(function (block) {
      const swiperEl = block.querySelector('.product-reviews-swiper');
      const paginationEl = block.querySelector('.product-reviews-pagination');
      if (!swiperEl || !paginationEl) return;

      if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }

      if (window.innerWidth <= 768) {
        new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 10,
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          loop: false,
          autoHeight: false,
        });
      }
    });
  }

  initProductReviewsSwipers();

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('.pdp-customer-reviews-block .product-reviews-swiper').forEach(function (el) {
        if (el.swiper) {
          el.swiper.destroy(true, true);
        }
      });
      initProductReviewsSwipers();
    }, 250);
  });
});
